import React, { useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const ACCENT = COLORS.primary_color_shade6 || "#039BE5";
const MODAL_RADIUS = 16;

const CONFIG = {
  board: {
    api: "addNewBoard.php",
    param: "board_name",
    title: "Add Board",
    label: "Board Name",
    placeholder: "e.g. CBSE",
    success: "Board added successfully!",
    error: "Could not add board.",
  },
  medium: {
    api: "addNewMedium.php",
    param: "medium_name",
    title: "Add Medium",
    label: "Medium Name",
    placeholder: "e.g. English",
    success: "Medium added successfully!",
    error: "Could not add medium.",
  },
};

const MODAL_STYLES = `
  .mdl-add-board-medium.modal-dialog {
    margin: 0.75rem auto 1.25rem;
    display: flex;
    align-items: center;
  }
  .mdl-add-board-medium .modal-content {
    border: none;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);
  }
  .mdl-add-board-medium .form-control {
    border-radius: 10px;
    border: 1px solid #e5e7eb;
  }
  .mdl-add-board-medium .modal-header .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }
`;

const MdlAddBoardMedium = ({ type, sessionId, actionClose, action2 }) => {
  const config = CONFIG[type] || CONFIG.board;
  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    setShow(false);
    actionClose();
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError(`Please enter a ${config.label.toLowerCase()}.`);
      return;
    }

    setError("");
    setLoading(true);

    try {
      const schoolCode = SessionManager.getSchoolCode();
      const url =
        process.env.REACT_APP_SERVER_NAME +
        process.env.REACT_APP_TARGET_DIR +
        config.api;

      const response = await axios.get(url, {
        params: {
          school_code: schoolCode,
          session_id: sessionId,
          [config.param]: name.trim(),
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success(response.data.api_remark || config.success);
        if (typeof action2 === "function") action2();
        handleClose();
      } else {
        myToast.notify_warning(response.data?.api_remark || config.error);
      }
    } catch (err) {
      console.error(`Add ${type} error:`, err);
      myToast.notify_error(`An error occurred while adding ${type}.`);
    } finally {
      setLoading(false);
    }
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <>
      <style>{MODAL_STYLES}</style>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        dialogClassName="mdl-add-board-medium"
        centered
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${ACCENT} 0%, ${COLORS.primary_color_shade7 || "#0288D1"} 100%)`,
            borderBottom: "none",
            color: "#fff",
          }}
        >
          <Modal.Title style={{ fontWeight: 800, color: "#fff" }}>
            <i
              className={`fa ${type === "board" ? "fa-university" : "fa-language"}`}
              style={{ marginRight: 8 }}
            />
            {config.title}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingTop: 18 }}>
          {loading ? (
            <MyLoader />
          ) : (
            <div>
              <Form.Label style={{ fontWeight: 700, fontSize: 13 }}>
                {config.label}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={config.placeholder}
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
                style={{ fontSize: 15, padding: "10px 12px", borderRadius: 10 }}
              />
              {error && (
                <div style={{ color: "#dc2626", fontSize: 12, marginTop: 6 }}>
                  {error}
                </div>
              )}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #e5e7eb" }}>
          <div className="d-flex justify-content-end w-100 gap-2">
            <Button variant="light" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={loading}
              style={{ background: ACCENT, borderColor: ACCENT, fontWeight: 700 }}
            >
              Add
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MdlAddBoardMedium;
